import { cssInterop } from "nativewind";
import {
  Chat as BaseGiftedChat,
  IMessage,
  InputToolbar as BaseInputToolbar,
} from "@kesha-antonov/react-native-chat";

cssInterop(BaseGiftedChat, {
  messagesContainerClassName: "messagesContainerStyle",
});

cssInterop(BaseInputToolbar, {
  className: "containerStyle",
  primaryClassName: "primaryStyle",
  wrapperClassName: "wrapperStyle",
});

declare module "@kesha-antonov/react-native-chat/lib/Chat/types" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface ChatProps<TMessage extends IMessage> {
    messagesContainerClassName?: string;
  }
}

declare module "@kesha-antonov/react-native-chat" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface InputToolbarProps<TMessage extends IMessage> {
    className?: string;
    primaryClassName?: string;
    wrapperClassName?: string;
  }
}

export const GiftedChat = BaseGiftedChat;
export const InputToolbar = BaseInputToolbar;
